// @flow
import type { DeliveryContactType } from './reducer';

export type SignUpDeliveryContactActionType =
  | {|
      type: 'SIGNUP_SET_DELIVERY_CONTACT',
      payload: {|
        deliveryContact: DeliveryContactType,
      |},
    |}
  | {|
      type: 'SET_DELIVERY_CONTACT_FAILURE',
      payload: { error: any },
    |};

export function setDeliveryContact(deliveryContact: DeliveryContactType): SignUpDeliveryContactActionType {
  return {
    type: 'SIGNUP_SET_DELIVERY_CONTACT',
    payload: {
      deliveryContact,
    },
  };
}

export const setDeliveryContactFailure = (error: any): SignUpDeliveryContactActionType => ({
  type: 'SET_DELIVERY_CONTACT_FAILURE',
  payload: {
    error,
  },
});
